import m from "mithril";
import { Button } from "../components/button/button";
import { dialog } from "../components/dialog/dialog";
import { IDX } from "./data/prorail";
import { getText } from "./translations";
const LOCAL_STORAGE_KEY = "tracksolutions.configurator.state";
const DEFAULT_LOCAL_STORAGE_VALUE = "v=2&wt=NORMAL_SWITCH%3AANGLE%3DLEFT&wl=CONCRETE&hv=1_9&sp=54E1&br=195";
const RECENT_SEARCHES_KEY = "tracksolutions.configurator.recentSearches";
export const MAX_RECENT_SEARCHES = 16;
export const useLocalStorage = async () => {
    if (location.search.includes("skip=1"))
        return true;
    const r = await dialog({ className: "start-dialog", title: getText("CONTINUE_CONFIGURATION"), dismiss: false }, c => [
        m("p", null,
            getText("CONTINUE_CONFIGURATION_DESCRIPTION"),
            " "),
        m("div", { className: "dialog-footer" },
            m(Button, { text: getText("CONFIGURE_NEW"), className: "button-ghost-default", onclick: () => {
                    localStorage.removeItem(LOCAL_STORAGE_KEY);
                    // localStorage.removeItem("property")
                    c("reset");
                } }),
            m(Button, { text: getText("CONFIGURE_EDIT"), icon: "icons/edit.svg", className: "button-ghost-default", onclick: () => c("load") }))
    ]).promise;
    return r === "load";
};
export const getLocalStorageValue = () => {
    return window.localStorage.getItem(LOCAL_STORAGE_KEY);
};
export const setLocalStorageValue = (value) => {
    window.localStorage.setItem(LOCAL_STORAGE_KEY, value);
};
export const hasLocalStorageValue = () => {
    const val = getLocalStorageValue();
    if (val == null || val == "")
        return false;
    if (getLocalStorageValue() === DEFAULT_LOCAL_STORAGE_VALUE)
        return false;
    return true;
};
export const getRecentSearches = () => {
    try {
        const raw = window.localStorage.getItem(RECENT_SEARCHES_KEY);
        return raw ? JSON.parse(raw) : [];
    }
    catch {
        return [];
    }
};
export const addRecentSearch = (item) => {
    const others = getRecentSearches().filter(x => !(x[IDX.key] === item[IDX.key] && x[IDX.equipmentId] === item[IDX.equipmentId]));
    others.unshift(item);
    window.localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(others.slice(0, MAX_RECENT_SEARCHES)));
};
export const removeRecentSearch = (key, equipmentId) => {
    const others = getRecentSearches().filter(x => !(x[IDX.key] === key && x[IDX.equipmentId] === equipmentId));
    window.localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(others));
};
